import React, { useState, useEffect } from "react";
import API from "../../api/axiosConfig";
import { toast } from "react-toastify";
import { FileText, Printer, Loader2 } from "lucide-react";

// Acciones de factura para un pedido ya cobrado (de mesa o de venta rápida): ver/
// descargar el PDF (abre en una pestaña nueva lista para Ctrl+P o guardar) y, si la
// sede tiene impresoras configuradas, mandarla como ticket térmico a la que se elija.
export default function InvoiceActions({ orderId, sedeId }) {
  const [stations, setStations] = useState([]);
  const [stationId, setStationId] = useState("");
  const [downloading, setDownloading] = useState(false);
  const [printing, setPrinting] = useState(false);

  useEffect(() => {
    if (!sedeId) return;
    API.get("/tables/print-stations", { params: { sedeId } })
      .then((res) => setStations(res.data?.data?.stations ?? []))
      .catch(() => {});
  }, [sedeId]);

  const downloadInvoice = async () => {
    setDownloading(true);
    try {
      const res = await API.get(`/tables/orders/${orderId}/invoice`, { responseType: "blob" });
      const url = URL.createObjectURL(new Blob([res.data], { type: "application/pdf" }));
      window.open(url, "_blank");
    } catch {
      toast.error("Error al generar la factura");
    } finally {
      setDownloading(false);
    }
  };

  const printInvoice = async () => {
    if (!stationId) { toast.warn("Elige una impresora"); return; }
    setPrinting(true);
    try {
      await API.post(`/tables/orders/${orderId}/invoice/print`, { stationId });
      toast.success("Factura enviada a imprimir");
    } catch (err) {
      toast.error(err.response?.data?.message || "Error al imprimir la factura");
    } finally {
      setPrinting(false);
    }
  };

  return (
    <div className="space-y-2 border border-gray-200 rounded-xl p-3 bg-gray-50">
      <p className="text-xs font-bold text-gray-500">Factura de venta</p>
      <button
        onClick={downloadInvoice}
        disabled={downloading}
        className="w-full flex items-center justify-center gap-2 py-2 rounded-lg border border-gray-200 bg-white hover:bg-gray-50 text-sm font-semibold text-gray-700 transition disabled:opacity-50"
      >
        {downloading ? <Loader2 size={14} className="animate-spin" /> : <FileText size={14} />} Ver / descargar PDF
      </button>
      {stations.length > 0 && (
        <div className="flex gap-2">
          <select
            className="flex-1 border border-gray-200 rounded-lg px-2 py-2 text-xs bg-white"
            value={stationId}
            onChange={(e) => setStationId(e.target.value)}
          >
            <option value="">Elige impresora...</option>
            {stations.map((s) => <option key={s.id} value={s.id}>{s.name}</option>)}
          </select>
          <button
            onClick={printInvoice}
            disabled={printing || !stationId}
            className="px-3 py-2 rounded-lg bg-gray-900 hover:bg-gray-800 text-white text-xs font-semibold transition disabled:opacity-50 flex items-center justify-center"
          >
            {printing ? <Loader2 size={14} className="animate-spin" /> : <Printer size={14} />}
          </button>
        </div>
      )}
    </div>
  );
}
